module.exports = __webpack_public_path__ + "img/06-红池坝.bb40572c.jpg";